// apis/drivers/get-vehicle-details.ts
import { useQuery } from "@tanstack/react-query";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const useGetVehicleDetails = () =>
    useQuery({
        queryKey: ["get_vehicle_details"],
        queryFn: async () => {
            const res = await apiClient.get(ENDPOINTS.DRIVER.VEHICLE_TYPE);
            return res.data;
        },
    });